import { useEffect, useState } from "react";
import { BreadCrum } from "../../common";
import CommonTable from "../../common/CommonTable";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { qceEmailColumns } from "./qceEmailColumns";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { claimReminderTemplateListHandler } from "../../redux/action/claimReminderTemplates";
import moment from "moment";
import Loader from "../Loder/loader";
import { useAdminPermissions } from "../../hooks/useAdminPermissions";

const QceTemplates = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    hasEmailTemplateViewOnly,
    hasPermission,
    isSuperAdmin,
    PERMISSIONS,
  } = useAdminPermissions();

  const showManageQceTemplate =
    isSuperAdmin || hasPermission(PERMISSIONS.EMAIL_TEMPLATE_EDIT);
  const showViewQceTemplate = hasEmailTemplateViewOnly;

  const columns = qceEmailColumns(navigate, {
    showManage: showManageQceTemplate,
    showView: showViewQceTemplate,
  });
  const [getQceTemplateList, setGetQceTemplateList] = useState([]);
  const getClaimReminderTemplatesList = useSelector(
    (state) => state?.getClaimReminderTemplates
  );

  useEffect(() => {
    if (getClaimReminderTemplatesList?.data?.data) {
      const qcelist = getClaimReminderTemplatesList?.data?.data?.map(
        (item) => ({
          // productId: item?.id,
          templateName: item?.templateName,
          dayOfMonth:item?.dayOfMonth,
          modifiedAt: moment(item.modifiedAt).format("MM/DD/YYYY"),
          emailBody: item?.emailBody,
          emailBodySpanish: item?.emailBodySpanish,
          emailSubject: item?.emailSubject,
          emailSubjectSpanish: item?.emailSubjectSpanish,
          enabled: item?.enabled,
          eventType: item?.eventType,
          id: item?.id,
          sms: item?.sms,
          timeOnly: item?.timeOnly,
          timeZone: item?.timeZone,
          dayOfWeek: item?.dayOfWeek,
          smsSpanish: item?.smsSpanish,
          scheduleType: item?.scheduleType,
          weekOfMonth: item?.weekOfMonth,
        })
      );
      setGetQceTemplateList(qcelist);
    }
  }, [getClaimReminderTemplatesList]);

  const handleClaimReminderList = () =>
    // offSet = 1,
    // limit = 10,
    // searchString = ""
    {
      window.scrollTo(0, 0);
      dispatch(claimReminderTemplateListHandler());
    };


  useEffect(() => {
    handleClaimReminderList();
  }, []);

  return (
    <>
    {getClaimReminderTemplatesList?.isLoading && (
      <Loader loaderTransform="loaderTransform" />
    )}
    <div className="rightside">
      <div className="rightcontent">
        <p>
          <strong>QCE Templates</strong>
        </p>
        <CustomBreadcrumb
          items={[
            { text: BreadCrum.HOME },
            { text: BreadCrum.QCE_TEMPLATE, active: true },
          ]}
        />

        <div className="table-padding">
          <div className="headtitle">
            <p className="mb-0 heedprodct">QCE Templates</p>
          </div>
          <hr className="m-0" />
          <div className="table-responsive">
            <CommonTable
              handlePageChange={handleClaimReminderList}
              columns={columns}
              body={getQceTemplateList}
              className="table usertable w-100"
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default QceTemplates;
